/**
 * Initialize Services Accordion Block Functionality
 */
function initServicesAccordion() {
  const blocks = document.querySelectorAll('.services-accordion-block')
  if (!blocks.length) return

  const transitionDuration = 500

  blocks.forEach(block => {
    const tabs = block.querySelectorAll('.services-tabs .services-tab-item button[data-tab-target]')
    const contentArea = block.querySelector('.service-accordion-content-area')
    const allContentPanels = contentArea
      ? Array.from(contentArea.querySelectorAll('.service-items-content'))
      : []
    const allServicesData = []

    const imageContainer = block.querySelector('.services-accordion-image-container')
    const actionLinkWrapper = block.querySelector('.service-action-link-wrapper')
    const actionLink = actionLinkWrapper
      ? actionLinkWrapper.querySelector('a.service-action-link')
      : null

    // Accordion Item Logic
    const accordionItems = block.querySelectorAll('.service-accordion-item')
    accordionItems.forEach(item => {
      const trigger = item.querySelector('button[aria-controls]')
      const content = item.querySelector('.service-accordion-content')
      const icon = trigger ? trigger.querySelector('.service-accordion-icon') : null

      if (!trigger || !content) return

      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true'
        trigger.setAttribute('aria-expanded', !isOpen)
        item.classList.toggle('is-open')

        if (!isOpen) {
          content.style.maxHeight = content.scrollHeight + 'px'
        } else {
          content.style.maxHeight = content.scrollHeight + 'px'
          requestAnimationFrame(() => {
            content.style.maxHeight = '0px'
          })
        }
      })

      if (!item.classList.contains('is-open')) {
        content.style.maxHeight = '0px'
      } else {
        content.style.maxHeight = content.scrollHeight + 'px'
        window.addEventListener('resize', () => {
          if (item.classList.contains('is-open')) {
            content.style.maxHeight = content.scrollHeight + 'px'
          }
        })
      }
    })

    // Tab Switching Logic
    if (tabs.length > 0 && contentArea && allContentPanels.length > 0) {
      allContentPanels.forEach((panel, index) => {
        allServicesData[index] = {
          url: panel.dataset.actionUrl,
          text: panel.dataset.actionText,
          target: panel.dataset.actionTarget || '_self',
        }
      })

      let activePanel = allContentPanels.find(panel => !panel.classList.contains('hidden')) // Find initially active panel

      const openFirstAccordion = panel => {
        if (!panel) return
        const firstAccordionItem = panel.querySelector('.service-accordion-item')
        if (firstAccordionItem && !firstAccordionItem.classList.contains('is-open')) {
          const trigger = firstAccordionItem.querySelector('button[aria-controls]')
          const content = firstAccordionItem.querySelector('.service-accordion-content')

          if (trigger && content) {
            trigger.setAttribute('aria-expanded', 'true')
            firstAccordionItem.classList.add('is-open')
            content.style.maxHeight = content.scrollHeight + 'px'
          }
        }
      }

      const showPanel = panel => {
        panel.classList.remove('hidden')
        requestAnimationFrame(() => {
          // Ensure 'hidden' is removed before opacity change
          panel.classList.remove('opacity-0')
          panel.classList.add('opacity-100')
          activePanel = panel // Update active panel reference
          openFirstAccordion(panel)
        })
      }

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          const targetId = tab.getAttribute('data-tab-target')
          const targetPanel = contentArea.querySelector('#' + targetId)

          if (!targetPanel || targetPanel === activePanel) return // Exit if not found or already active

          if (imageContainer && !imageContainer.classList.contains('hidden')) {
            imageContainer.classList.add('hidden')
          }

          if (actionLinkWrapper) {
            const serviceData = allServicesData[index]
            if (actionLink && serviceData && serviceData.url && serviceData.text) {
              const linkP = actionLink.querySelector('p')
              actionLink.href = serviceData.url
              actionLink.target = serviceData.target
              if (linkP) {
                linkP.textContent = serviceData.text
              }
              actionLinkWrapper.classList.remove('hidden')
            } else {
              actionLinkWrapper.classList.add('hidden')
            }
          }

          // Update tab states immediately
          tabs.forEach(t => {
            const isCurrent = t === tab
            t.setAttribute('aria-selected', isCurrent)
            if (isCurrent) {
              t.classList.remove('paragraph-md')
              t.classList.add('heading-sm')
            } else {
              t.classList.remove('heading-sm')
              t.classList.add('paragraph-md')
            }
          })

          // Function to handle hiding the old panel after transition
          const hideOldPanel = event => {
            if (activePanel && event.propertyName === 'opacity' && event.target === activePanel) {
              activePanel.classList.add('hidden')
              activePanel.removeEventListener('transitionend', hideOldPanel) // Clean up listener

              // Now show the new panel
              showPanel(targetPanel)
            }
          }

          // Fallback timer function
          let fallbackTimer = null
          const startFallbackTimer = () => {
            fallbackTimer = setTimeout(() => {
              // Check if the active panel hasn't changed and it's still meant to be hidden
              if (
                activePanel &&
                activePanel !== targetPanel &&
                !activePanel.classList.contains('hidden')
              ) {
                console.warn('Transitionend event fallback triggered for hiding panel.')
                if (activePanel) activePanel.removeEventListener('transitionend', hideOldPanel) // Clean up listener just in case
                activePanel.classList.add('hidden') // Force hide
                // Now show the new panel
                showPanel(targetPanel)
              }
            }, transitionDuration + 100) // Slightly longer buffer
          }

          // Start fade out of the currently active panel
          if (activePanel) {
            // Clear any previous fallback timer for this panel
            if (activePanel.fallbackTimerId) {
              clearTimeout(activePanel.fallbackTimerId)
            }
            activePanel.classList.remove('opacity-100')
            activePanel.classList.add('opacity-0')
            // Add listener to hide it *after* fade out completes
            activePanel.addEventListener('transitionend', hideOldPanel)
            // Start a fallback timer
            startFallbackTimer()
            activePanel.fallbackTimerId = fallbackTimer // Store timer ID on the element
          } else {
            // If no panel was active initially, just show the new one directly
            showPanel(targetPanel)
          }
        })
      })
    }
  })
}

document.addEventListener('DOMContentLoaded', () => {
  initServicesAccordion()
})
